import { all, put, takeEvery, select } from 'redux-saga/effects'

import {
  CREATE_FAILURE,
  CREATE_SUCCESS,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  GET_LIST_FAILURE,
  GET_SIMPLE_FAILURE,
  GET_MANY_FAILURE,
  GET_MANY_REFERENCE_FAILURE,
  GET_ONE_FAILURE,
  UPDATE_FAILURE,
  UPDATE_SUCCESS,
} from '@/state/types/data'
import { getCurrentRoute } from '@/state/selectors'
import { showNotification } from '@/state/actions/notification'
import { goToPage } from '@/state/actions/routes'
// import resolveRedirectTo from '@/utils/resolveRedirectTo'

/**
 * Side effects for fetch responses
 *
 * Mostly redirects and notifications
 */
function* handleResponse({ type, requestPayload, error, payload }) {
  const sagas = []
  let redirectTo
  switch (type) {
    case UPDATE_SUCCESS:
      if (requestPayload.hasOwnProperty('redirectTo') && requestPayload.redirectTo !== false) {
        redirectTo = [requestPayload.redirectTo, null, { id: payload.data.id }]
      } else {
        const route = yield select(getCurrentRoute)
        if (route.redirectToList) {
          redirectTo = [route.redirectToList]
        } else if (route.redirectToSingle) {
          redirectTo = [route.redirectToSingle, null, { id: payload.data.id }]
        }
      }
      if (redirectTo) {
        sagas.push(yield put(goToPage(...redirectTo)))
      }
      if (requestPayload.message !== false) {
        sagas.push(
          yield put(
            showNotification(UPDATE_SUCCESS, requestPayload.message || 'i18n.notification.updated'),
          ),
        )
      }
      return yield all(sagas)
    /*       return redirectTo
        ? yield all([
            put(
              showNotification(
                UPDATE_SUCCESS,
                requestPayload.message || 'i18n.notification.updated',
              ),
            ),
            put(goToPage(...redirectTo)),
          ])
        : yield [
            put(
              showNotification(
                UPDATE_SUCCESS,
                requestPayload.message || 'i18n.notification.updated',
              ),
            ),
          ] */

    case CREATE_SUCCESS:
      if (requestPayload.hasOwnProperty('redirectTo') && requestPayload.redirectTo !== false) {
        redirectTo = [requestPayload.redirectTo, null, { id: payload.data.id }]
      } else {
        const route = yield select(getCurrentRoute)
        if (route.redirectToList) {
          redirectTo = [route.redirectToList]
        } else if (route.redirectToSingle) {
          redirectTo = [route.redirectToSingle, null, { id: payload.data.id }]
        }
      }
      if (redirectTo) {
        sagas.push(yield put(goToPage(...redirectTo)))
      }
      if (requestPayload.message !== false) {
        sagas.push(
          yield put(
            showNotification(CREATE_SUCCESS, requestPayload.message || 'i18n.notification.created'),
          ),
        )
      }
      return yield all(sagas)
    /*       return redirectTo
        ? yield all([
            put(
              showNotification(
                CREATE_SUCCESS,
                requestPayload.message || 'i18n.notification.created',
              ),
            ),
            put(goToPage(...redirectTo)),
          ])
        : yield [
            put(
              showNotification(
                CREATE_SUCCESS,
                requestPayload.message || 'i18n.notification.created',
              ),
            ),
          ] */

    case DELETE_SUCCESS:
      if (requestPayload.hasOwnProperty('redirectTo') && requestPayload.redirectTo !== false) {
        redirectTo = [requestPayload.redirectTo, null, { id: payload.data.id }]
      } else {
        const route = yield select(getCurrentRoute)
        if (route.redirectToList) {
          redirectTo = [route.redirectToList]
        } else if (route.redirectToSingle) {
          redirectTo = [route.redirectToSingle, null, { id: payload.data.id }]
        }
      }
      if (redirectTo) {
        sagas.push(yield put(goToPage(...redirectTo)))
      }
      if (requestPayload.message !== false) {
        sagas.push(
          yield put(
            showNotification(DELETE_SUCCESS, requestPayload.message || 'i18n.notification.deleted'),
          ),
        )
      }
      return yield all(sagas)
    /*       return redirectTo
        ? yield all([
            put(
              showNotification(
                DELETE_SUCCESS,
                requestPayload.message || 'i18n.notification.deleted',
              ),
            ),
            put(goToPage(...redirectTo)),
          ])
        : yield [
            put(
              showNotification(
                DELETE_SUCCESS,
                requestPayload.message || 'i18n.notification.deleted',
              ),
            ),
          ] */

    case GET_ONE_FAILURE:
      return requestPayload.basePath
        ? yield all([
            put(
              showNotification(GET_ONE_FAILURE, 'i18n.notification.item_doesnt_exist', {
                type: 'warning',
              }),
            ),
            // put(push(requestPayload.basePath))
          ])
        : yield all([])

    case GET_LIST_FAILURE:
    case GET_MANY_FAILURE:
    case GET_SIMPLE_FAILURE:
    case GET_MANY_REFERENCE_FAILURE:
    case CREATE_FAILURE:
    case UPDATE_FAILURE:
    case DELETE_FAILURE: {
      const errorMessage =
        typeof error === 'string' ? error : error.message || 'i18n.notification.http_error'
      return yield put(showNotification(type, errorMessage, { type: 'warning' }))
    }
    default:
      return yield all([])
  }
}

// put(goToPage(redirectTo, null, { id: payload.data.id })),
// put(
//   push(
//     resolveRedirectTo(
//       requestPayload.redirectTo,
//       requestPayload.basePath,
//       requestPayload.id
//     )
//   )
// )

export default function*() {
  yield takeEvery(action => action.meta && action.meta.fetchResponse, handleResponse)
}



// WEBPACK FOOTER //
// ./state/sagas/crudResponse.js